module.exports = __webpack_public_path__ + "media/WildPig.0d6349b5.mp3";